"use client";

import React from "react";
import { FaShieldAlt } from "react-icons/fa";

export default function TermConditon() {
    return (
        <main className="min-h-screen bg-white py-36 px-6">
            <div className="max-w-6xl mx-auto  rounded-2xl  p-10">
                {/* Header Section */}
                <div className="text-center mb-20">
                    <FaShieldAlt className="text-blue-600 text-6xl mx-auto mb-4" />
                    <h1 className="text-4xl font-bold text-gray-900">
                        Sureship – Refund & Cancellation Policy
                    </h1>
                    <p className="text-gray-500 mt-2">
                        Last Updated: October 2025 | Please read carefully before use.
                    </p>
                </div>

                {/* Intro Section */}
                <section className="space-y-4 text-gray-700 leading-relaxed mb-10">
                    <p>
                        Your privacy is important to us. This privacy statement provides
                        information about the personal information that Sureship collects,
                        and the ways in which Sureship uses that personal information. We
                        collect, the personal basic Information about you including your
                        name, email address, Contact details etc.
                    </p>

                    <ul className="list-disc ml-6 space-y-2 text-gray-700">
                        <li>
                            You may cancel your account at anytime by emailing
                            support@sureship.in
                        </li>
                        <li>
                            If you cancel the Service in the middle of the month, you will
                            receive one final invoice via email. Once that invoice has been
                            paid you will not be charged again.
                        </li>
                        <li>
                            We reserve the right to modify or terminate the Bigship.in service
                            for any reason, without notice at any time.
                        </li>
                        <li>
                            Fraud: Without limiting any other remedies, Bigship.in may suspend
                            or terminate your account if we suspect that you (by conviction,
                            settlement, insurance or escrow investigation, or otherwise) have
                            engaged in fraudulent activity in connection with the Site.
                        </li>
                    </ul>
                </section>

                {/* Footer */}
                <footer className="border-t border-gray-200 pt-6 text-center text-gray-600 text-sm">
                    <p>
                        &copy; {new Date().getFullYear()} Sureship Logistics Pvt. Ltd. | All
                        Rights Reserved.
                    </p>
                    <p className="mt-1">
                        For questions, please contact{" "}
                        <a
                            href="mailto:support@sureship.in"
                            className="text-blue-600 underline hover:text-blue-800"
                        >
                            support@sureship.in
                        </a>
                    </p>
                </footer>
            </div>
        </main>
    );
}
